import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionsList,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import {
  RadioGroup,
  RadioGroupItem,
} from "@babackapp/customer-ui/components/radio-group";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { ArrowLeft, RefreshCcw, WalletIcon } from "lucide-react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { useLineItemResolutionForm } from "../../hooks/use-line-item-resolution-form";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";

export function Resolution() {
  const { form, onSubmit, availableResolutions, isRetractationItem, formattedShippingCost } = useLineItemResolutionForm();
  const t = useCustomText();

  const RESOLUTION_CONFIG: Record<
    "refund" | "exchange",
    { icon: React.ReactNode; title: string; description: string }
  > = {
    refund: {
      icon: <WalletIcon />,
      title: t("resolution.refund.title"),
      description: isRetractationItem
        ? t("returnMethod.retractation.costInfo", { amount: formattedShippingCost })
        : t("resolution.refund.description"),
    },
    exchange: {
      icon: <RefreshCcw />,
      title: t("resolution.exchange.title"),
      description: t("resolution.exchange.description"),
    },
  };

  // Hook will navigate away when only one resolution — render nothing in the meantime
  if (availableResolutions.length <= 1) return null;

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>{t("resolution.title")}</HeaderTitle>
        <HeaderDescription>
          {t("resolution.description")}
        </HeaderDescription>
      </Header>

      <form onSubmit={onSubmit}>
        <Controller
          control={form.control}
          name="resolution"
          render={({ field }) => (
            <OptionsList>
              <RadioGroup value={field.value} onValueChange={field.onChange}>
                {availableResolutions.map((value) => {
                  const config = RESOLUTION_CONFIG[value];
                  return (
                    <Label key={value} htmlFor={`resolution-${value}`}>
                      <Option>
                        <OptionIcon>{config.icon}</OptionIcon>
                        <OptionTitle>{config.title}</OptionTitle>
                        <OptionDescription>{config.description}</OptionDescription>
                        <OptionAction>
                          <RadioGroupItem value={value} id={`resolution-${value}`} />
                        </OptionAction>
                      </Option>
                    </Label>
                  );
                })}
              </RadioGroup>
            </OptionsList>
          )}
        />

        <AnimatedButtonRow variants={{}}>
          <AnimatedButtonContainer
            layoutId="line-item-back-button"
            disableVariants={{ exit: true }}
          >
            <Link to="../reason">
              <Button variant="secondary" type="button">
                <ArrowLeft />
                {t("common.back")}
              </Button>
            </Link>
          </AnimatedButtonContainer>
          <AnimatedButtonContainer
            layoutId="line-item-confirm-button"
            disableVariants={{ enter: true, exit: true }}
          >
            <Button type="submit">
              <EnterIcon />
              {t("common.confirm")}
            </Button>
          </AnimatedButtonContainer>
        </AnimatedButtonRow>
      </form>
    </WidgetPage>
  );
}
